/* Albert Tusk — Featured collections card: AJAX Add to cart only.
   File: assets/at-fc-card.js (loaded by sections/featured-collection.liquid)
   Touches nothing outside .at-fc-card — existing wishlist, product page and
   theme scripts are not affected. */
(() => {
  if (window.__atFcCard) return;
  window.__atFcCard = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function showMsg(btn, text) {
    const msg = btn.closest('[data-at-card]')?.querySelector('.at-fc-card__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    clearTimeout(msg._t);
    msg._t = setTimeout(() => { msg.hidden = true; }, 4000);
  }

  async function openCart() {
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
    const store = window.Alpine && typeof Alpine.store === 'function' && Alpine.store('xMiniCart');
    if (store) {
      if (typeof store.reLoad === 'function') { try { await store.reLoad(); } catch (e) {} }
      if (typeof store.openCart === 'function') { store.openCart(); return; }
      return;
    }
    window.location.href = ROOT + 'cart';
  }

  async function addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;
    const id = Number(btn.dataset.variantId);
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: Math.max(1, Number(btn.dataset.qty) || 1) }] }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
      await openCart();
    } catch (err) {
      showMsg(btn, err.message || 'Could not add to cart.');
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.at-fc-card [data-at-atc]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* Heart state only (READ-ONLY). Clicks + saving are handled by the existing
     card-product-premium.js (key "pc:wishlist"); this just marks hearts in
     cards that appear after its boot, e.g. the Men tab. Never writes storage. */
  const WISH_KEY = 'pc:wishlist';
  function syncHearts() {
    let list = [];
    try { list = JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) {}
    if (!Array.isArray(list)) list = [];
    document.querySelectorAll('.at-fc-card [data-pc-wish]').forEach((b) => {
      const on = list.indexOf(b.getAttribute('data-product-handle')) > -1 ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
  }
  document.addEventListener('pc:wishlist', syncHearts);
  window.addEventListener('storage', (e) => { if (e.key === WISH_KEY) syncHearts(); });
  window.addEventListener('pageshow', syncHearts);

  let queued = false;
  const watch = () => {
    syncHearts();
    document.querySelectorAll('.x-container-featured-collection').forEach((root) => {
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; syncHearts(); });
      }).observe(root, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();